import { render, staticRenderFns } from "./UserDefinedComponent.vue?vue&type=template&id=472cd996&scoped=true&"
import script from "./UserDefinedComponent.vue?vue&type=script&lang=js&"
export * from "./UserDefinedComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserDefinedComponent.vue?vue&type=style&index=0&id=472cd996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472cd996",
  null
  
)

export default component.exports